import { render, staticRenderFns } from "./textGenerateList.vue?vue&type=template&id=36053698&scoped=true&"
import script from "./textGenerateList.ts?vue&type=script&lang=js&"
export * from "./textGenerateList.ts?vue&type=script&lang=js&"
import style0 from "./textGenerateList.less?vue&type=style&index=0&id=36053698&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36053698",
  null
  
)

export default component.exports